import status from "@/locales/languages/es_MX/view/operativos/status";
import substatus from "@/locales/languages/es_MX/view/operativos/substatus";
import accion from "@/locales/languages/es_MX/view/operativos/accion";
import vendor from "@/locales/languages/es_MX/view/operativos/vendor";
import rep from "@/locales/languages/es_MX/view/operativos/rep";
import campana from "@/locales/languages/es_MX/view/operativos/campana";
import agregador from "@/locales/languages/es_MX/view/operativos/agregador";
import benefpref from "@/locales/languages/es_MX/view/operativos/benefpref";
import tipo from "@/locales/languages/es_MX/view/operativos/tipo";
import contact from "@/locales/languages/es_MX/view/operativos/contact";
import popEntryExit from "@/locales/languages/es_MX/view/operativos/popEntryExit";
import posTest from "@/locales/languages/es_MX/view/operativos/posTest";
import shoppings from "@/locales/languages/es_MX/view/operativos/shoppings";
import statusPreContacto from "@/locales/languages/es_MX/view/operativos/statusPreContacto";
import se from "@/locales/languages/es_MX/view/operativos/se";
import seOOB from "@/locales/languages/es_MX/view/operativos/seOOB";
import acuerdo from "@/locales/languages/es_MX/view/operativos/acuerdo";
import subindustria from "@/locales/languages/es_MX/view/operativos/subindustria";
import banco from "@/locales/languages/es_MX/view/operativos/banco";
import codigoindustrial from "@/locales/languages/es_MX/view/operativos/codigoindustrial";
import partner from "@/locales/languages/es_MX/view/operativos/partner";
import proveedorpos from "@/locales/languages/es_MX/view/operativos/proveedorpos";
import merchandising from "@/locales/languages/es_MX/view/operativos/merchandising";
import canalaceptacion from "@/locales/languages/es_MX/view/operativos/canalaceptacion";
import iniciativa from "@/locales/languages/es_MX/view/operativos/iniciativa";
import motivobaja from "@/locales/languages/es_MX/view/operativos/motivobaja";

export default {
  status
  , substatus
  , accion
  , vendor
  , rep
  , campana
  , agregador
  , benefpref
  , tipo
  , contact
  , popEntryExit
  , posTest
  , shoppings
  , statusPreContacto
  , se
  , seOOB
  , acuerdo
  , subindustria
  , banco
  , codigoindustrial
  , partner
  , proveedorpos
  , merchandising
  , canalaceptacion
  , iniciativa
  , motivobaja
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/index.js